import { logAuditEvent } from './auditLogs.service'

const parseJsonSafe = async (resp) => {
  const text = await resp.text().catch(() => '')
  try {
    return { json: JSON.parse(text), text }
  } catch (_e) {
    return { json: null, text }
  }
}

const sanitizeEnvValue = (value) => typeof value === 'string' ? value.trim().replace(/^['"]|['"]$/g, '').trim() : value

export const createMercadoPagoPreference = async ({ orderId, storefrontUrl, orderSnapshot, trace, traceId }) => {
  const baseUrl = sanitizeEnvValue(import.meta.env.VITE_API_BASE_URL) || ''
  const url = `${baseUrl}/api/mercadopago/preference`
  let responseInfo = null
  try {
    const resp = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ orderId, storefrontUrl, orderSnapshot, trace, traceId })
    })
    const contentType = resp.headers.get('content-type') || ''
    const { json, text } = await parseJsonSafe(resp)
    if (!resp.ok) {
      const details = json?.details ? `: ${json.details}` : ''
      const stage = json?.stage ? ` [${json.stage}]` : ''
      const requestId = json?.requestId ? ` (${json.requestId})` : ''
      const message = json?.error ? `${json.error}${details}${stage}${requestId}` : (text?.slice(0, 160) || `Error MercadoPago: ${resp.status}`)
      responseInfo = {
        status: resp.status,
        error: json?.error || null,
        details: json?.details || null,
        stage: json?.stage || null,
        requestId: json?.requestId || null,
        text: text?.slice(0, 200) || null
      }
      throw new Error(message)
    }
    if (!json?.initPoint && !json?.sandboxInitPoint) {
      const message = contentType.includes('text/html')
        ? 'No se encontró el endpoint de MercadoPago (configuración pendiente)'
        : json?.error || 'Respuesta inválida del servidor de pagos'
      responseInfo = {
        status: resp.status,
        error: json?.error || null,
        details: json?.details || null,
        stage: json?.stage || null,
        requestId: json?.requestId || null,
        contentType,
        text: text?.slice(0, 200) || null
      }
      throw new Error(message)
    }
    return json
  } catch (error) {
    const message = error?.message || 'No se pudo generar el link de MercadoPago'
    await logAuditEvent({
      level: 'error',
      category: 'payments',
      action: 'mp_preference_client_error',
      message,
      metadata: {
        orderId,
        storefrontUrl,
        url,
        response: responseInfo
      },
      error
    })
    throw new Error(message)
  }
}

export const syncMercadoPagoOrderPayment = async (orderId, options = {}) => {
  const baseUrl = sanitizeEnvValue(import.meta.env.VITE_API_BASE_URL) || ''
  const params = new URLSearchParams({ orderId })
  if (options?.trace === true || options?.trace === 'true' || options?.trace === '1') {
    params.set('trace', '1')
  }
  if (options?.traceId) {
    params.set('traceId', String(options.traceId))
  }
  const url = `${baseUrl}/api/mercadopago/webhook?${params.toString()}`
  try {
    const resp = await fetch(url, { method: 'GET' })
    const { json, text } = await parseJsonSafe(resp)
    if (!resp.ok) {
      const details = json?.details ? `: ${json.details}` : ''
      const stage = json?.stage ? ` [${json.stage}]` : ''
      const requestId = json?.requestId ? ` (${json.requestId})` : ''
      const message = json?.error ? `${json.error}${details}${stage}${requestId}` : (text?.slice(0, 160) || `Error MercadoPago: ${resp.status}`)
      throw new Error(message)
    }
    return json
  } catch (error) {
    const message = error?.message || 'No se pudo sincronizar el estado de pago con MercadoPago'
    throw new Error(message)
  }
}

export default {
  createMercadoPagoPreference,
  syncMercadoPagoOrderPayment
}
